module.exports = __webpack_public_path__ + "img/compass.95a1e177.svg";